//import { useNavigate } from 'react-router-dom';
import axios from '../api/axios';
import { setCredentials } from '../redux/features/auth/authSlice';
import { useAppDispatch } from '../redux/hooks/hook';
import useAuth from './useAuth';
import useLogout from './useLogout';

const useRefreshToken = () => {
    const { setAuth } = useAuth()
    const logOut = useLogout()
    const dispatch = useAppDispatch()
    //const history = useNavigate()

    const refresh = async () => {
        try{
            const response = await axios.post('/auth/refresh', {}, {
                withCredentials: true
            });

            if (response.data.access_token) {
                const { access_token, permissions, user, menus } = response.data;

                setAuth(prev => {
                    //console.log(JSON.stringify(prev));
                    //console.log(JSON.stringify(response.data));
                    //console.log(response.data.access_token);
                    return { 
                        ...prev, 
                        accessToken: access_token,
                        permissions: permissions,
                        user: user,
                        email: user.email,
                        menus: menus
                    };
                });

                dispatch(setCredentials({ user:user, accessToken:access_token }))

                return response.data.access_token;
            } else {
                // No access token received, redirect to login
                //history('/login');
                logOut()
                return null;
            }

        } catch (error) {
            // Handle any errors here
            //console.error('Error refreshing token:', error);
            // Redirect to login page on error
            //history.push('/login');
            //history('/login');
            logOut()
            return null;
        }
    }
    return refresh;
};

export default useRefreshToken;